import { createFocusTrap, type FocusTrap } from 'focus-trap';

export class FocusTrapService {
  private defaultFocusTrapOptions = {
    allowOutsideClick: true,
    escapeDeactivates: true,
    returnFocusOnDeactivate: true,
  };

  /**
   * Initialize a new focus trap.
   *
   * @param targetArray - Selector or Node to use as the focus trap target.
   * @param options - Options to pass into the focus-trap constructor.
   * @returns A new FocusTrap instance.
   */
  initializeFocusTrap(targetArray: string[], options?: Record<string, unknown>) {
    return createFocusTrap(targetArray, { ...options, ...this.defaultFocusTrapOptions });
  }

  activateFocusTrap(instance: FocusTrap | null) {
    setTimeout(() => {
      if (!instance) {
        return;
      }

      instance.activate();
    }, 50);
  }

  deactivateFocusTrap(instance: FocusTrap | null) {
    if (!instance) {
      return;
    }

    instance.deactivate();
  }
}
